import registerRootComponent from "expo/build/launch/registerRootComponent"
import i18nextInstance from "@services/i18next"
import { App } from "./src/App"

i18nextInstance()
registerRootComponent(App)
